var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.users
    ? _c(
        "div",
        { staticClass: "searchbar-found", attrs: { id: "users-list" } },
        [
          _c(
            "table",
            {
              staticClass: "table table-hover w-100",
              attrs: { role: "table", "aria-label": "Liste des utilisateurs" },
            },
            [
              _c("caption", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.$t("administration.users_list_description"))),
              ]),
              _vm._v(" "),
              _c("thead", [
                _c("tr", { attrs: { role: "row" } }, [
                  _c(
                    "th",
                    {
                      staticClass: "text-center",
                      attrs: { scope: "col", id: "user-id-header" },
                    },
                    [_vm._v(_vm._s(_vm.$t("administration.user_id")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "text-center",
                      attrs: { scope: "col", id: "user-login-header" },
                    },
                    [_vm._v(_vm._s(_vm.$t("administration.user_login")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "text-center",
                      attrs: { scope: "col", id: "user-name-header" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("administration.user_firstname_name"))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "text-center sr-only",
                      attrs: { scope: "col", id: "actions-header" },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.actions")))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.users, function (usersGroup, key) {
                    return [
                      _c(
                        "tr",
                        {
                          key: "group-" + key,
                          staticClass: "group-title",
                          attrs: { role: "row" },
                        },
                        [
                          _c(
                            "th",
                            {
                              staticClass: "font-weight-bold",
                              attrs: { colspan: "4", scope: "colgroup" },
                            },
                            [_vm._v(_vm._s(key))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(usersGroup, function (user) {
                        return _c(
                          "tr",
                          {
                            key: user.Id,
                            class: {
                              "boxRequest clickable":
                                _vm.canGetUserAccountDetail(),
                            },
                            attrs: {
                              role: "row",
                              "aria-label": _vm.canGetUserAccountDetail()
                                ? _vm.$t("administration.view_user_details", {
                                    name: user.Name,
                                  })
                                : undefined,
                            },
                            on: {
                              click: function ($event) {
                                _vm.canGetUserAccountDetail()
                                  ? _vm.seeDetails(user)
                                  : _vm.seeDetails()
                              },
                            },
                          },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "text-center",
                                attrs: { headers: "user-id-header" },
                              },
                              [_vm._v(_vm._s(user.Id))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "text-center",
                                attrs: { headers: "user-login-header" },
                              },
                              [_vm._v(_vm._s(user.Login))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "text-center",
                                attrs: { headers: "user-name-header" },
                              },
                              [_vm._v(_vm._s(user.Name))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "text-center sr-only",
                                attrs: { headers: "actions-header" },
                              },
                              [
                                _vm.canGetUserAccountDetail()
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("administration.clickable_row")
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                    ]
                  }),
                ],
                2
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }